import React from "react";
import { Button, EmptyState } from "@jsq/ds/core";

export const PageNotFound: React.FC = () => {
  const handleContactSupport = () => {
    window.open("mailto:support@junipersquare.com", "_blank");
  };

  return (
    <EmptyState
      illustration="searching"
      title="There&#39;s nothing here"
      description="This page doesn&#39;t exist, or your subscription is in Review. Contact your team&#39;s admin to confirm, or reach out to support."
    >
      <Button onClick={handleContactSupport} variant="neutral">
        Contact support
      </Button>
    </EmptyState>
  );
};
